import { render, staticRenderFns } from "./ToProcessFileAllFiles.vue?vue&type=template&id=ca0f5586&scoped=true"
import script from "./ToProcessFileAllFiles.vue?vue&type=script&lang=ts"
export * from "./ToProcessFileAllFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0f5586",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca0f5586')) {
      api.createRecord('ca0f5586', component.options)
    } else {
      api.reload('ca0f5586', component.options)
    }
    module.hot.accept("./ToProcessFileAllFiles.vue?vue&type=template&id=ca0f5586&scoped=true", function () {
      api.rerender('ca0f5586', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/ToProcessFileAllFiles.vue"
export default component.exports